<template>
  <va-create-layout>
    <fuel-storages-form :title="title" :item="item"></fuel-storages-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ['title', 'item'],
}
</script>
